import React, { useState, Fragment, useEffect } from 'react';
import 'rc-datepicker/lib/style.css';
import './style.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import { handleValidateObj } from 'constants/objValues/objvalues';
import DatePicker from 'components/sales/datePicker/datePicker';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';

const CategoryDetails = ({
  isSupply = false,
  isApartments = false,
  isB2b = false,
  handleValue,
  supplyNameFun = null,
  splNameData = null,
  rwaTenureFun = null,
  rwaTenureData = null,
  supDropDownData,
  corDropDownData,
  appartmentDropDown,
  prefilledData = null,
  isDefalut,
  isEdit=false,
}) => {
  const demandInputs = {
    leadCat: { id: null, value: '' },
    leadCatId: '',
    supplyName: { id: null, value: '' },
    vms: { id: null, value: '' },
    slotsNo: '',
    reservedSlots: '',
    fcfsSlots: '',
    evChargersNo: ''
  };
  const suplyInputs = {
    gatesNo: '',
  };

  const appartmentInputs = {
    date: '',
    gatesNo: '',
    carsNo: '',
    rwaTenure: { id: null, value: '' },
    vms: { id: null, value: '' },
    flatNo: '',
    evChargersNo: '',
    partners: { id: null, value: '' }
  };

  const aptOptInputs = {
    carsNo: '',
    HelpStaffNo: '',
    avgChFlat: '',
    requirDesc: '',
    vms: { id: null, value: '' },
  };

  const [categoryDemandData, setCategoryDemandData] = useState(demandInputs);
  const [categorySupplyData, setCategorySupplyData] = useState(suplyInputs);
  const [categoryArtData, setCategoryArtData] = useState(appartmentInputs);
  const [aptOpt, setAptOpt] = useState(aptOptInputs);
  const [isDemand, setIsDemand] = useState(null);
  const [categories, setCategories] = useState();
  const [partners, setPartners] = useState();
  const [products, setProducts] = useState();

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setCategoryDemandData(demandInputs);
      setCategorySupplyData(suplyInputs);
      setCategoryArtData(appartmentInputs);
      setAptOpt(aptOptInputs);
      setIsDemand(null);
      setCategories();
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        lead_category,
        lead_category_id,
        fcfs,
        no_of_gates,
        reserved,
        no_of_slots,
        no_of_cars,
        no_of_flats,
        no_of_staff,
        rwa_details,
        supply_id,
        vms_type_id,
        vms_type,
        supply_name,
        requirements_description,
        no_of_ev_chargers,
        partner,
        partner_id
      } = prefilledData?.lead_data;
      setIsDemand(lead_category_id);
      setCategoryDemandData({
        ...categoryDemandData,
        leadCat: { id: lead_category_id, value: lead_category },
        vms: {
          id: `${vms_type_id}`,
          value: `${vms_type}`
        },
        slotsNo: `${no_of_slots}`,
        fcfsSlots: `${fcfs}`,
        reservedSlots: `${reserved}`,
        supplyName: { id: supply_id, value: supply_name },
        evChargersNo: `${no_of_ev_chargers}`,
      });
      setCategorySupplyData({
        ...categorySupplyData,
        gatesNo: `${no_of_gates}`,
        vms: {
          id: `${vms_type_id}`,
          value: `${vms_type}`
        },
        slotsNo: `${no_of_slots}`,
      });
      setCategoryArtData({
        ...categoryArtData,
        gatesNo: `${no_of_gates}`,
        rwaTenure: {
          id: `${rwa_details?.tenure}`,
          value: `${rwa_details?.tenure}`,
        },
        vms: {
          id: `${vms_type_id}`,
          value: `${vms_type}`
        },
        carsNo: `${no_of_cars}`,
        flatNo: `${no_of_flats}`,
        date: `${rwa_details?.rwa_end_date}`,
        slotsNo: `${no_of_slots}`,
        evChargersNo: `${no_of_ev_chargers}`,
        partners: {
          id: partner_id,
          value: partner
        }
      });
      console.log(categoryArtData);
      setAptOpt({
        ...aptOpt,
        carsNo: `${no_of_cars}`,
        HelpStaffNo: `${no_of_staff}`,
        avgChFlat: `${rwa_details?.maintenance_charge}`,
        requirDesc: requirements_description,
        vms: {
          id: `${vms_type_id}`,
          value: `${vms_type}`
        },
      });
    }
  }, [prefilledData]);

  useEffect(() => {
    if (supDropDownData) {
      const { categories } = supDropDownData;
      setCategories(categories);
    }
  }, [supDropDownData]);

  useEffect(() => {
    if (corDropDownData) {
      const { categories, strategic_partner, products } = corDropDownData;
      setCategories(categories);
      setPartners(strategic_partner);
      setProducts(products);
    }
  }, [corDropDownData]);

  useEffect(() => {
    if (appartmentDropDown) {
      const { categories } = appartmentDropDown;
      setCategories(categories);
    }
  }, [appartmentDropDown]);

  useEffect(() => {
    if (supplyNameFun !== null) (async () => await supplyNameFun())();
    if (rwaTenureFun !== null) (async () => await rwaTenureFun())();
  }, [supplyNameFun, rwaTenureFun]);

  const handleDemand = ({ id, value }) => {
    setIsDemand(id);
    setCategoryDemandData({
      ...categoryDemandData,
      leadCat: { id: id, value: value },
      leadCatId: id,
      slotsNo: '',
    });
    setCategorySupplyData({ ...categorySupplyData, gatesNo: '' });
    setCategoryArtData({ ...categoryArtData, gatesNo: '' });
  };

  const handleDateChange = (jsdate) =>
    setCategoryArtData({ ...categoryArtData, date: jsdate });

  useEffect(() => {
    const formatDate = handleFormatDate();
    setCategoryArtData({ ...categoryArtData, date: formatDate });
  }, []);

  const handleCategoryData = () => {
    if (isSupply === true) {
      const supplyCatObj = {
        leadCatId: categoryDemandData.leadCat.id,
      };
      const isNotEmpty = handleValidateObj(supplyCatObj);
      if (isNotEmpty !== false) {
        handleValue({ ...supplyCatObj, requirDesc: aptOpt.requirDesc });
      }
    }
    if (isApartments === true) {
      const apartmentsObj = {
        leadCatId: categoryDemandData.leadCat.id,
        gatesNo: categoryArtData.gatesNo,
        flatNo: categoryArtData.flatNo,
        date: categoryArtData.date,
        rwaTenure: categoryArtData.rwaTenure.id,
      };
      const isNotEmpty = handleValidateObj(apartmentsObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...apartmentsObj,
          slotsNo: categoryDemandData.slotsNo,
          carsNo: aptOpt.carsNo,
          HelpStaffNo: aptOpt.HelpStaffNo,
          avgChFlat: aptOpt.avgChFlat,
        });
      }
    }
    if (isB2b === false) {
      if (isDemand === '') handleValue(null);
      if (isSupply === false) {
        if (isApartments === false) {
          if (isDemand === 2) {
            if (categoryDemandData.slotsNo !== '') {
              const demandobj = { ...categoryDemandData };
              demandobj.leadCat = categoryDemandData.leadCat.value;
              handleValue({
                ...demandobj,
                leadCatId: categoryDemandData.leadCat.id,
                supplyName: categoryDemandData.supplyName.id,
                reservedSlots: categoryDemandData.reservedSlots,
                fcfsSlots: categoryDemandData.fcfsSlots,
                vms: categoryDemandData.vms.id,
              });
            } else {
              handleValue(null);
            }
          } else if (isDemand === 3 || isDemand === 1 || isDemand === 8 || isDemand === 12) {
            if (isApartments === false) {
              if (isDemand === 1) {
                // console.log('as')
                let objGate = categorySupplyData.gatesNo;
                const isNotEmpty = handleValidateObj({ objGate });
                if (isNotEmpty !== false) {
                  handleValue({
                    ...categorySupplyData,
                    leadCat: categoryDemandData.leadCat.value,
                    leadCatId: categoryDemandData.leadCat.id,
                    slotsNo: categoryDemandData.slotsNo,
                    vms: categoryDemandData.vms.id,
                    evChargersNo: categoryDemandData.evChargersNo,
                    // products: categoryDemandData.products
                  });
                }
              }else if(isDemand === 8 || isDemand === 12){
                  console.log(categoryDemandData);
                  let objGate = 1;
                // const isNotEmpty = handleValidateObj({ objGate });
                  handleValue({
                    // ...categorySupplyData,
                    gatesNo: 1,
                    leadCat: categoryDemandData.leadCat.value,
                    leadCatId: categoryDemandData.leadCat.id,
                    slotsNo: categoryDemandData.slotsNo,
                    vms: categoryDemandData.vms.id,
                    partners: categoryDemandData.partner
                  });
              } else if(isDemand === 3) {
                if (isDemand === 3 && isApartments === false) {
                  const isObj = categoryDemandData.slotsNo;
                  const isEmpty = handleValidateObj({ isObj });
                  if (isEmpty !== false) {
                    handleValue({
                      leadcat: categoryDemandData.leadCat.value,
                      leadCatId: categoryDemandData.leadCat.id,
                      gatesNo: categorySupplyData.gatesNo,
                      slotsNo: categoryDemandData.slotsNo,
                      vms: categoryDemandData.vms.id,
                    });
                  }
                }
              }else{
                let objGate = 1;
                // const isNotEmpty = handleValidateObj({ objGate });
                if (objGate)
                  handleValue({
                    ...categorySupplyData,
                    leadCat: categoryDemandData.leadCat.value,
                    leadCatId: categoryDemandData.leadCat.id,
                    slotsNo: categoryDemandData.slotsNo,
                    vms: categoryDemandData.vms.id,
                  });
              }
            }
          }
        }
      }
    }
  };

  useEffect(() => {
    handleCategoryData();
  }, [
    categoryDemandData,
    isDemand,
    categorySupplyData,
    categoryArtData,
    aptOpt,
  ]);

  const handleSupplyName = () => {
    if (isDemand === 2) {
      return (
        <Fragment>
          <DropDownInput
            data={splNameData}
            label={localization.supplyNamePost}
            getIdValue={(val) =>
              setCategoryDemandData({
                ...categoryDemandData,
                supplyName: { id: val.id, value: val.value },
              })
            }
            value={categoryDemandData.supplyName.value}
          />
          <ConstantInput
            label={localization.noOfSlots}
            regex={Regex.numericNotZero.test(categoryDemandData.slotsNo)}
            errorMsg={
              categoryDemandData.slotsNo === ''
                ? localization.requiredSlot
                : localization.enterValidData
            }
            type="number"
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, slotsNo: val })
            }
            value={`${categoryDemandData?.slotsNo}`}
          />
          <ConstantInput
            label={localization.reservedSlots}
            regex={Regex.number.test(categoryDemandData.reservedSlots)}
            errorMsg={localization.requiredReserve}
            errorMsg={
              categoryDemandData.reservedSlots
                ? localization.numericError
                : localization.requiredReserve
            }
            type="text"
            maxLength={3}
            handleChange={(val) =>
              setCategoryDemandData({
                ...categoryDemandData,
                reservedSlots: val,
              })
            }
            value={categoryDemandData.reservedSlots}
          />
          <ConstantInput
            label={localization.FCFSSlots}
            regex={Regex.number.test(categoryDemandData.fcfsSlots)}
            errorMsg={
              categoryDemandData.fcfsSlots
                ? localization.numericError
                : localization.requiredFCFSslot
            }
            type="text"
            maxLength={3}
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, fcfsSlots: val })
            }
            value={categoryDemandData.fcfsSlots}
          />
           <DropDownInput
              label={localization.vms}
              data={rwaTenureData.vmsType}
              getIdValue={(val) =>
                setCategoryDemandData({
                  ...categoryDemandData,
                  vms: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={categoryDemandData.vms.value}
            />
        </Fragment>
      );
    }
  };

  const handleofGates = () => {
    if (isDemand === 3 || isDemand === 1) {
      return (
        <Fragment>
          {isDemand === 3 ? (
            <ConstantInput
              label={localization.noOfSlots}
              regex={
                isApartments
                  ? null
                  : Regex.numericNotZero.test(categoryDemandData.slotsNo)
              }
              errorMsg={
                categoryDemandData.slotsNo
                  ? localization.numericError
                  : localization.requiredSlot
              }
              type="text"
              maxLength={3}
              handleChange={(val) =>
                setCategoryDemandData({ ...categoryDemandData, slotsNo: val })
              }
              required={isApartments ? false : true}
              value={categorySupplyData.slotsNo}
            />
          ) : null}
          {isEdit ? null: 
          <DropDownInput
          label={localization.productService}
          multipule={true}
          data={products}
          getIdValue={(val) =>
            setCategoryDemandData({
              ...categoryDemandData,
              products: val,
            })
          }
          isStarRequired={true}
          required
          isBottom
          value={categoryArtData.products}
        />
          }
          
          <ConstantInput
            label={localization.noOfgates}
            regex={Regex.number.test(
              isApartments
                ? categoryArtData.gatesNo
                : categorySupplyData.gatesNo
            )}
            errorMsg={
              isApartments
                ? categoryArtData.gatesNo === ''
                  ? localization.requiredGate
                  : localization.validDataForNoOfGates
                : categorySupplyData.gatesNo === ''
                ? localization.requiredGate
                : localization.validDataForNoOfGates
            }
            type="number"
            handleChange={(val) => {
              isApartments
                ? setCategoryArtData({ ...categoryArtData, gatesNo: val })
                : setCategorySupplyData({
                    ...categorySupplyData,
                    gatesNo: val,
                  });
            }}
            maxLength={4}
            isStarRequired={true}
            required={(isDemand === 3 && isApartments === false) ? true : false}
            value={categoryArtData.gatesNo}
          />
          <ConstantInput
            label={localization.noOfSlots}
            regex={Regex.number.test(categoryDemandData.slotsNo)}
            errorMsg={
              categoryDemandData.slotsNo === ''
                ? localization.requiredSlot
                : localization.enterValidData
            }
            isStarRequired={true}
            type="number"
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, slotsNo: val })
            }
            value={categoryArtData?.slotsNo}
          />
          <ConstantInput
            label={localization.noOfEVChargers}
            regex={Regex.number.test(categoryDemandData.evChargersNo)}
            errorMsg={
              categoryDemandData.evChargersNo === ''
                ? localization.requiredEVCharger
                : localization.enterValidData
            }
            isStarRequired={true}
            type="number"
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, evChargersNo: val })
            }
            value={categoryArtData?.evChargersNo}
          />
           <DropDownInput
              label={localization.vms}
              data={rwaTenureData.vmsType}
              getIdValue={(val) =>
                setCategoryDemandData({
                  ...categoryDemandData,
                  vms: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={categoryArtData.vms.value}
            />
        </Fragment>
      );
    }
    if (isDemand == 8) {
      return (
        <Fragment>
          <DropDownInput
              label={localization.strategicPartnerselect}
              data={partners}
              // multipule={true}
              getIdValue={(val) =>
                setCategoryDemandData({
                  ...categoryDemandData,
                  partner: { id: val.id, value: val.value },
                })
              }
              required
              isStarRequired={true}
              isBottom
              value={categoryArtData.partners.value}
            />
        </Fragment>
      );
    }
  };

  return (
    <Fragment>
      <FormSection title={localization.categoryDetails}>
      <div className="form-ctrl-col">
        <DropDownInput
          label={localization.LeadCategory}
          data={categories}
          getIdValue={(val) => handleDemand(val)}
          errorMsg={localization.requiredLeadCateg}
          required
          isBottom
          value={categoryDemandData.leadCat.value}
        />
        {isSupply ? (
          <Fragment>
            <ConstantInput
              label={localization.reqDes}
              type="text"
              handleChange={(val) => setAptOpt({ ...aptOpt, requirDesc: val })}
              value={aptOpt.requirDesc}
            />
          </Fragment>
        ) : (
          <Fragment>
            {isApartments === true ? null : handleSupplyName()}{' '}
            {handleofGates()}
          </Fragment>
        )}
        {isApartments ? (
          <Fragment>
            <ConstantInput
              label={localization.noOfCars}
              regex={Regex.number.test(aptOpt.carsNo)}
              errorMsg={
                aptOpt.carsNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              handleChange={(val) => {
                setAptOpt({
                  ...aptOpt,
                  carsNo: val.replace(/^0+/, ''),
                });
              }}
              value={aptOpt.carsNo}
              isNotZero
            />
            <ConstantInput
              label={localization.noOfFlats}
              regex={Regex.number.test(categoryArtData.flatNo)}
              errorMsg={
                categoryArtData.flatNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              required
              handleChange={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  flatNo: val.replace(/^0+/, ''),
                })
              }
              value={categoryArtData.flatNo}
              isNotZero
            />
            <ConstantInput
              label={localization.noOfHelpingStaff}
              regex={Regex.number.test(aptOpt.HelpStaffNo)}
              errorMsg={
                aptOpt.HelpStaffNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              handleChange={(val) =>
                setAptOpt({ ...aptOpt, HelpStaffNo: val.replace(/^0+/, '') })
              }
              value={aptOpt.HelpStaffNo}
              isNotZero
            />

            <DatePicker
              handleChange={(val) => handleDateChange(val)}
              label={localization.RWADate}
              value={categoryArtData.date}
            />
            <DropDownInput
              label={localization.RWATenure}
              errorMsg={localization.isRequired}
              data={rwaTenureData}
              getIdValue={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  rwaTenure: { id: val.id, value: val.value },
                })
              }
              required
              isBottom
              value={categoryArtData.rwaTenure.value}
            />
            <ConstantInput
              label={localization.AverageMaintenance}
              type="number"
              regex={Regex.toFixed.test(aptOpt.avgChFlatr)}
              handleChange={(val) => setAptOpt({ ...aptOpt, avgChFlat: val })}
              value={aptOpt.avgChFlat}
            />
          </Fragment>
        ) : null}
        </div>
      </FormSection>
    </Fragment>
  );
};

export default CategoryDetails;